import fetch from 'isomorphic-fetch';
import config from '../config';

export async function uploadProfilePicture(file, token, userId) {
  let data = new FormData();
  data.append('file', file);
  const url = config.apiUrl + '/upload?mediaType=profileImage' + (userId ? '&userId=' + userId : '');
  let headers = {Accept: 'application/json', authorization: `Bearer ${token}`};
  return fetch(url, {method: 'POST', headers, body: data});
}



// WEBPACK FOOTER //
// ./src/helpers/uploadHelper.js